module.exports = __webpack_public_path__ + "img/icon_sms_gray.4a6fcebe.svg";